const sizes = ['Bytes', 'KB', 'MB', 'GB']

export default function readableBytes(bytes: number): string {
  if (bytes === 0) {
    return '0 Byte'
  }

  const sizeScale = Number(Math.floor(Math.log(bytes) / Math.log(1024)))
  return `${parseFloat((bytes / Math.pow(1024, sizeScale)).toFixed(2))} ${sizes[sizeScale]}`
}
